module.exports = __webpack_public_path__ + "static/media/11NEPAD9.12bfef3a.jpg";